export const SIMPLE_SURVEY_STATUS = 'SIMPLE';
